(function () {
    'use strict';

    angular
        .module('app')
        .controller('EntityTemplatesListCtrl', EntityTemplatesListCtrl);

    EntityTemplatesListCtrl.$inject = ['$q', 'SystemService', 'DialogService', 'ChilliUserProfileService', 'WindowTitleService'];

    function EntityTemplatesListCtrl($q, SystemService, DialogService, ChilliUserProfileService, WindowTitleService) {
        /* jshint validthis:true */
        var vm = this;
        vm.dashboardSettingConfiguration = null;
        vm.showPanel = showPanel;
        vm.loading = true;
        vm.permissionDenied = false;

        activate();

        function activate() {
            WindowTitleService.setTitle('Entity Templates');

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadEverything,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () { vm.loading = false; }
            });

            function loadEverything() {
                var loadPromises = [];
                loadPromises.push(loadListPageSize());

                return $q.all(loadPromises).then(function () {
                    var dashboardSettingConfiguration = {};
                    dashboardSettingConfiguration.ListPageSize = vm.ListPageSize;

                    vm.dashboardSettingConfiguration = angular.copy(dashboardSettingConfiguration);
                });
            }
        }

        function loadListPageSize() {
            return SystemService.getMenuListSize('Entity Templates')
                .then(getListPageSizeOk, getListPageSizeError);

            function getListPageSizeOk(data) {
                vm.ListPageSize = data;
            }

            function getListPageSizeError(response) {
                DialogService.error('Error fetching list size', response);
            }
        }

        function showPanel() {
            return !_.isNil(vm.dashboardSettingConfiguration);
        }
    }
})();
